import TipJar from './TipJar'
export default TipJar
